import { render, staticRenderFns } from "./AllotmentForm.vue?vue&type=template&id=6a9cb854&scoped=true&"
import script from "./AllotmentForm.vue?vue&type=script&lang=js&"
export * from "./AllotmentForm.vue?vue&type=script&lang=js&"
import style0 from "./AllotmentForm.vue?vue&type=style&index=0&id=6a9cb854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9cb854",
  null
  
)

export default component.exports